<template>
  <div class="ftbg">

    <div class="vendor-pic">
      <div class="v-p-item">
        <img src="../assets/images/ft/PG.png" class="top-1 pg" alt="">
      </div>
      <div class="v-p-item">
        <img src="../assets/images/ft/logo.png" class="middle-2 logo" alt="">
        <img src="../assets/images/ft/PP.png" class="left-1 pp" alt="">
        <img src="../assets/images/ft/CP.png" class="left-2 cp" alt="">
        <img src="../assets/images/ft/AMBS.png" class="right-1 ambs" alt="">
        <img src="../assets/images/ft/JDB.png" class="right-2 jdb" alt="">
      </div>
      <div class="v-p-item">
        <img src="../assets/images/ft/TADA.png" class="bottom-3 tada" alt="">
      </div>
    </div>
    <div class="cr">
      <div class="description">
        As melhores caça-níqueis online do mundo <span id="lightname">{{ $store.state.config.site_name
        }}</span>
        O Grupo é a empresa de operações de casino online mais famosa do mundo,
        e ofer ece uma cidade de entretenimento ao vivo, xadrez, eletrónica, pesca,
        I otaria, desporto, etc. O Grupo está autorizado e regulamentado pelo G overno de Curacao,
        e opera de acordo com a licença (N.° Antillephon e) emitida para 777/JAZ. O Grupo obteve aprovação em todas as
        auditorias jorias regulamentares,
        e está legalmente autorizado a operar todos os ogos de azar e apostas.
      </div>
    </div>
    <div class="thwrap">
      <div class="logoss">
        <img src="../assets/images/ft/1.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/2.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/3.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/4.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/5.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/6.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/7.png" class="other_logo2" alt="">
      </div>
      <div class="logoss">
        <img src="../assets/images/ft/8.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/9.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/10.png" class="other_logo2" alt="">
        <img src="../assets/images/ft/11.png" class="other_logo2" alt="">
      </div>
    </div>
    <div class="text-wrapper_4" style="color: #fff;font-size: 9px;">
      <span id="lightname" class="text_name"> {{ $store.state.config.site_name }}&nbsp;&nbsp;</span>
      <span></span>
      <span>&nbsp;&nbsp;&nbsp;Copyright@2025</span>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    jump(i) {
      this.$bus.$emit("send2index", i)
    }
  }
}

</script>
<style scoped lang="less">
@import "../assets/css/variables.less";
.text-wrapper_4{
  text-align: center;
  .text_name{
    border-right: 1px solid #fff;
  }
}
.vendor-pic {
  width: 100%;
  height: fit-content;
  margin: .9375rem auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: .5rem;
  box-sizing: border-box;

  .v-p-item {
    width: 33.33%;
    height: fit-content;
    position: relative;

    img {
      width: 100%;
      height: auto;
      display: block;
      cursor: pointer;
    }

    .middle-2 {
      // min-height: 6.25rem;
      height: auto !important;
    }

    .left-1 {
      right: 100%;
      top: 0;
    }

    .left-2 {
      right: 100%;
      top: 100%;
    }

    .right-1 {
      left: 100%;
      top: 0;
    }

    .right-2 {
      left: 100%;
      top: 100%;

    }
  }
}

.vendor-pic .left-1,
.vendor-pic .left-2,
.vendor-pic .right-1,
.vendor-pic .right-2 {
  position: absolute;
  transform: translateY(-50%);
}

#lightname {
  color: @rechargeColor;
}

.ftbg {
  background-color: @activityColor;
  padding-bottom: 2.5rem;
}

.wrappp {
  width: 95%;
  margin: 0 auto;
  padding: 10px 0;
  display: flex;
  border-bottom: 0.04rem solid @bodercolor;
}

.scwrap {
  width: 95%;
  margin: 0 auto;
  padding: 10px 0;
  border-bottom: 0.05rem solid @bodercolor;
}

.thwrap {
  width: 95%;
  margin: 0 auto;
  padding: 10px 0;
}

.logos {
  width: 50%;
  margin: 0.3rem auto;
  display: flex;
  justify-content: space-around;
}

.other_logo {
  width: 1rem;
  height: 1rem;
}

.logoss {
  width: 100%;
  margin: 0.3rem auto;
  display: flex;
  justify-content: center;
}

.other_logo2 {
  width: 1.3rem;
  // height: 0.6rem;
  margin: 0 0.05rem;
  //color: #777777;
}

.description {
  color: @textcolor3;
  font-size: 0.25rem;
  line-height: 1.5;
  margin-bottom: 0.3rem;
}

.ft_nav {
  width: 33%;
  text-align: left;
  box-sizing: border-box;
  padding: 0.5rem 0.3rem 0.5rem 0.2rem;
}

.nav_head {
  height: 1rem;
  line-height: 1rem;
  color: @textcolor2;
}

.nav_item {
  display: block;
  height: 0.5rem;
  color: @anttextcolor;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.cr {
  width: 95%;
  margin: 0 auto;
  // padding-bottom: 25px;
  text-align: center;
  color: #e14ce1;
  // padding-top: 0.8rem;
  // border-top: 1px solid @bodercolor;
}


.footer-logos {
  background-image: linear-gradient(90deg,
      rgba(138, 53, 128, 1) 0,
      rgba(138, 53, 128, 1) 0,
      rgba(111, 7, 184, 1) 100%,
      rgba(111, 7, 184, 1) 100%);
  display: flex;
  width: 92%;
  margin: .5rem auto;
  flex-wrap: wrap;
  justify-content: space-between;
  border-radius: .3rem;
  padding: .3rem;
}

.footer-logos img {
  width: 23%;
}

.footer-imgs img {
  width: 30px;
}
</style>